export default {
    header: "Ordini di {name}",
    error: "Si è verificato un errore",
    empty: "Nessun ordine trovato",
    system: "Servizio di assistenza",
    orders: {
        name: "Nome",
        date: "Data",
        status: "Stato",
        approvedBy: "Approvato da"
    },
    cta: {
        close: "Vicino"
    }
}